/* global angular */
( function () {
	'use strict';

	function ppdFactory ( apiService ) {
		var resources = {
			'attachedPDs'     : [ ],
			'recommendedPDs'  : [ ],
			'baseSource'      : { },
			'location'        : '',
			'viewDisabled'    : false,
			'attribute'       : '',
			'isAutoSave'      : false,
			'resourceId'      : null,
			'subResourceId'   : null,
			'readOnly'        : false,
			'uploadedFiles'   : [ ],
			'masterSource'    : { },
			'templatePreview' : false,
			'fileType'        : 19
		};

		function setNavs ( location ) {
			var categories = [ 'Videos', 'Micro-Credentials', 'Attach Files' ];

			var navs = {
				'observation' : [ 'Assigned', 'Recommended' ],
				'template'    : [ 'Attached' ]
			};

			return navs[ location ].concat( categories );
		}

		function setIcons () {
			var iconType = {
				'1' : 'fa fa-play',
				'2' : 'fa fa-paperclip'
			};

			return iconType;
		}

		function setOptions ( options ) {
			var obsAttr = 'prescribedResources';
			var tplAttr = 'templateAttachments';

			resources.attribute       = options.location === 'observation' &&  obsAttr || tplAttr;
			resources.location        = options.location;
			resources.viewDisabled    = options.viewDisabled;
			resources.readOnly        = options.readOnly;
			resources.templatePreview = Boolean( options.templatePreview );
		}

		function setResource ( resource ) {
			resources.resourceId = resource.resourceId;
		}

		function setMasterSource ( masterSource ) {
			resources.masterSource = masterSource;
		}

		function setUploadedFiles ( uploadedFiles ) {
			resources.uploadedFiles = uploadedFiles;
		}

		function removeFromCollection ( collection, item ) {
			collection = collection.filter( function ( filterItem ) {
				return filterItem.id !== item.id;
			} );

			return collection;
		}

		function updateCollection ( collection, item ) {
			return collection.map( function ( mapItem ) {
				if ( mapItem.id === item.id ) {
					mapItem = item;
				}

				return mapItem;
			} );
		}

		function addToCollection ( collection, item ) {
			collection = collection.concat( item );

			return collection;
		}

		function attachProps ( collection, mapCollection ) {
			collection.forEach( function ( item ) {
				mapCollection = updateCollection( mapCollection, item );
			} );

			return mapCollection;
		}

		function wrapObj ( obj, key ) {
			return ( obj || {} )[ key ];
		}

		function getResourceId () {
			return resources.resourceId;
		}

		function getAttachedPDs () {
			return resources.attachedPDs.map( function ( item ) {
				item.isAttached = true;

				return item;
			} );
		}

		function getRecommendedPDs () {
			return attachProps( getAttachedPDs(), resources.recommendedPDs );
		}

		function getBaseSource () {
			return resources.baseSource;
		}

		function getLocation () {
			return resources.location;
		}

		function getAttribute () {
			return resources.attribute;
		}

		function getUploadedFiles () {
			return resources.uploadedFiles;
		}

		function isReadOnly () {
			return resources.readOnly;
		}

		function isViewDisabled () {
			return resources.viewDisabled;
		}

		function isTemplatePreview () {
			return resources.templatePreview;
		}

		function getMasterSource () {
			return resources.masterSource;
		}

		function setBaseCollection ( resource ) {
			var copySource = angular.copy( resource );

			resources.attachedPDs = wrapObj( copySource, resources.attribute ) || [ ];

			resources.attachedPDs.map( function ( item ) {
				item.id   = item.id || item.contentId || item.ContentId;
				item.name = item.name || item.contentName || item.ContentName;

				return item;
			} );

			resources.recommendedPDs = wrapObj( copySource.template, 'templateAttachments' ) || wrapObj( copySource, 'templateAttachments' ) || [ ];

			// the base source
			resources.baseSource = resource;
		}

		function updateBaseSource () {
			resources.baseSource[ resources.attribute ] = angular.copy( resources.attachedPDs );
		}

		function attachData ( item ) {
			resources.attachedPDs    = addToCollection( resources.attachedPDs, item );
			resources.recommendedPDs = updateCollection( resources.recommendedPDs, item );

			updateBaseSource();
		}

		function detachData ( item ) {
			resources.recommendedPDs = updateCollection( resources.recommendedPDs, item );
			resources.attachedPDs    = removeFromCollection( resources.attachedPDs, item );

			updateBaseSource();
		}

		function updateData ( item ) {
			resources.attachedPDs    = updateCollection( resources.attachedPDs, item );
			resources.recommendedPDs = updateCollection( resources.recommendedPDs, item );

			updateBaseSource();
		}

		function getContentDetails ( params ) {
			return apiService.getContentDetails.get( params ).$promise;
		}

		function getFileType () {
			return resources.fileType;
		}

		function updateMasterSource ( data ) {
			var obj    = getMasterSource();
			var attr   = getAttribute();

			var groups = attr === 'templateAttachments' && obj.groups || obj.template.groups;

			obj[ attr ] = ( obj[ attr ] || [ ] ).filter( function ( item ) {
				return item.id !== data.id;
			} );

			groups.forEach( function ( group ) {
				group[ attr ] = ( group[ attr ] || [ ] ).filter( function ( groupItem ) {
					return groupItem.id !== data.id;
				} );

				group.indicators.forEach( function ( indicator ) {
					indicator[ attr ] = ( indicator[ attr ] || [ ] ).filter( function ( indicatorItem ) {
						return indicatorItem.id !== data.id;
					} );
				} );
			} );
		}

		return {
			'setNavs'              : setNavs,
			'setIcons'             : setIcons,
			'setBaseCollection'    : setBaseCollection,
			'setOptions'           : setOptions,
			'setResource'          : setResource,
			'setMasterSource'      : setMasterSource,
			'setUploadedFiles'     : setUploadedFiles,
			'addToCollection'      : addToCollection,
			'removeFromCollection' : removeFromCollection,
			'updateCollection'     : updateCollection,
			'attachProps'          : attachProps,
			'attachData'           : attachData,
			'detachData'           : detachData,
			'updateData'           : updateData,
			'getContentDetails'    : getContentDetails,
			'getAttachedPDs'       : getAttachedPDs,
			'getRecommendedPDs'    : getRecommendedPDs,
			'getBaseSource'        : getBaseSource,
			'getLocation'          : getLocation,
			'getAttribute'         : getAttribute,
			'isViewDisabled'       : isViewDisabled,
			'isTemplatePreview'    : isTemplatePreview,
			'isReadOnly'           : isReadOnly,
			'getResourceId'        : getResourceId,
			'getUploadedFiles'     : getUploadedFiles,
			'getMasterSource'      : getMasterSource,
			'updateMasterSource'   : updateMasterSource,
			'getFileType'          : getFileType
		};
	}

	angular
		.module( 'app.components' )
		.factory( 'ppdFactory', ppdFactory );
} )();
